/**
 * ============================================================
 * Feature Engine
 * MiningSurveyWebGIS
 * ============================================================
 */

import Geometry from "./geometry.js";

class Feature {
    /**
     * =========================================================
     * Create Feature
     * =========================================================
     */

    create(placemark, style = {}) {
        const layer = Geometry.create(placemark, style);

        if (!layer) return null;

        Geometry.saveOriginalStyle(layer);

        const feature = {
            id: crypto.randomUUID(),

            name: placemark.name || "",

            description: placemark.description || "",

            style,

            geometry: placemark.geometry,

            properties: placemark.properties || {},

            layer,

            visible: true,
        };

        // simpan referensi ke layer
        layer.feature = feature;

        return feature;
    }

    /**
     * =========================================================
     * Visibility
     * =========================================================
     */

    setVisible(feature, visible) {
        feature.visible = visible;
    }

    isVisible(feature) {
        return feature.visible;
    }

    /**
     * =========================================================
     * Name
     * =========================================================
     */

    getName(feature) {
        return feature.name;
    }

    setName(feature, name) {
        feature.name = name;
    }

    /**
     * =========================================================
     * Properties
     * =========================================================
     */

    getProperties(feature) {
        return feature.properties;
    }

    getProperty(feature, key) {
        return feature.properties[key];
    }

    setProperty(feature, key, value) {
        feature.properties[key] = value;
    }

    /**
     * =========================================================
     * Elevation
     * =========================================================
     */

    getElevation(feature) {
        const p = feature.properties;

        return p.Elevation ?? p.ELEVATION ?? p.Elev ?? p.ELEV ?? p.RL ?? p.Rl ?? p.rl ?? p.Z ?? p.z ?? p.Altitude ?? p.ALT ?? p.alt ?? (feature.description && !isNaN(Number(feature.description)) ? Number(feature.description) : null);
    }

    /**
     * =========================================================
     * Bounds
     * =========================================================
     */

    getBounds(feature) {
        return Geometry.getBounds(feature.layer);
    }

    /**
     * =========================================================
     * Center
     * =========================================================
     */

    getCenter(feature) {
        return Geometry.getCenter(feature.layer);
    }

    /**
     * =========================================================
     * Highlight
     * =========================================================
     */

    highlight(feature) {
        const layer = feature.layer;

        if (!layer.setStyle) return;

        layer.setStyle({
            weight: (layer.options.weight || 2) + 2,
        });
    }

    /**
     * =========================================================
     * Restore
     * =========================================================
     */

    restore(feature) {
        Geometry.restoreOriginalStyle(feature.layer);
    }
}

export default new Feature();
